import { Cn as L, yn as C } from "./icon-CJVFAm1E.js";
import { t as j } from "./isDefined-fMi6eQ4r.js";
import { t as F } from "./OverflowingTextWithTooltip-Q3WsleFe.js";
import { n as i, r as t, t as e } from "./ListItem.module-2-JdpOva.js";
import { clsx as o } from "clsx";
import { Fragment as H, jsx as a, jsxs as u } from "react/jsx-runtime";
import { isNonEmptyArray as M, isString as S } from "@sniptt/guards";
import q from "react";
import { useRender as w } from "@base-ui/react/use-render";
var A = "_commandTextContainer_2o210_1", E = "_commandText_2o210_1", O = "_commandKey_2o210_15", p = {
  commandTextContainer: A,
  commandText: E,
  commandKey: O
}, W = ({ hotKeys: n, joinLabel: r = "then" }) => /* @__PURE__ */ a("div", {
  className: p.commandText,
  children: n && /* @__PURE__ */ a("div", {
    className: p.commandTextContainer,
    children: n.map((m, s) => /* @__PURE__ */ u(q.Fragment, { children: [/* @__PURE__ */ a("div", {
      className: p.commandKey,
      children: m
    }), s < n.length - 1 && r] }, s))
  })
}), z = ({ checked: n, disabled: r }) => /* @__PURE__ */ a("span", {
  "aria-hidden": !0,
  className: o(i.root, i.solid, i.sm, i.square, i.accent),
  "data-checked": n || void 0,
  "data-disabled": r || void 0,
  children: /* @__PURE__ */ a("span", {
    className: i.box,
    children: n && /* @__PURE__ */ a("span", {
      className: i.indicator,
      children: /* @__PURE__ */ a(C, { "aria-hidden": !0 })
    })
  })
}), Z = ({ color: n = "neutral", selected: r = !1, focused: m = !1, disabled: s = !1, indicator: c = "none", startIcon: f, endIcon: N, description: l, descriptionPlacement: v = "inline", actions: x, actionsVisibility: k = "hover", hotkeys: _, hasSubmenu: y = !1, className: T, children: d, render: b, ref: D, onClick: I, ...K }) => {
  const g = t(l), R = (h) => {
    if (s) {
      h.preventDefault();
      return;
    }
    j(I) && (h.stopPropagation(), I(h));
  };
  return w({
    render: b,
    ref: D,
    state: {
      color: n,
      indicator: c,
      selected: r,
      highlighted: m,
      disabled: s
    },
    props: {
      ...K,
      "data-actions-visibility": k,
      className: o(e.root, T),
      "aria-disabled": s || void 0,
      onClick: R,
      children: /* @__PURE__ */ u(H, { children: [
        c === "checkbox" && /* @__PURE__ */ a(z, {
          checked: r,
          disabled: s
        }),
        t(f) && /* @__PURE__ */ a("span", {
          className: e.startIcon,
          children: f
        }),
        /* @__PURE__ */ u("span", {
          className: e.label,
          children: [/* @__PURE__ */ a("span", {
            className: e.text,
            children: S(d) ? /* @__PURE__ */ a(F, { text: d }) : d
          }), g && v === "inline" && /* @__PURE__ */ a("span", {
            className: o(e.description, e.inlineDescription),
            children: l
          })]
        }),
        g && v === "end" && /* @__PURE__ */ a("span", {
          className: o(e.description, e.endDescription),
          children: l
        }),
        t(x) && /* @__PURE__ */ a("span", {
          className: e.actions,
          children: x
        }),
        M(_) && /* @__PURE__ */ a("span", {
          className: e.hotkeys,
          children: /* @__PURE__ */ a(W, { hotKeys: _ })
        }),
        t(N) && /* @__PURE__ */ a("span", {
          className: e.endIcon,
          children: N
        }),
        c === "check" && r && /* @__PURE__ */ a(C, {
          className: e.checkIndicator,
          "aria-hidden": !0
        }),
        y && /* @__PURE__ */ a(L, {
          className: e.submenuIcon,
          "aria-hidden": !0
        })
      ] })
    }
  });
};
export {
  W as n,
  Z as t
};
